import React, { createContext, useContext, useState, useCallback } from 'react';

const AuthContext = createContext();

const PASS_HASH = '0819';

export function AuthProvider({ children }) {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showLogin, setShowLogin] = useState(false);

  const login = useCallback((password) => {
    if (password === PASS_HASH) {
      setIsLoggedIn(true);
      setShowLogin(false);
      return true;
    }
    return false;
  }, []);

  const logout = useCallback(() => {
    setIsLoggedIn(false);
  }, []);

  return (
    <AuthContext.Provider value={{ isLoggedIn, showLogin, setShowLogin, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
